// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1538":"090ee668baaabea0","1545":"fc63b3029b80d771","6368":"734aebc28802bf09","6504":"1d8fa29df13d83f4"}[chunkId] + ".js";
};